import { Button, Card } from '@nextui-org/react';
import { AnimatePresence, motion, wrap } from 'framer-motion';
import { useEffect, useState } from 'react';
import client from '../apollo-client';
import Bismillah from '../components/Bismillah';
import BookCard from '../components/BookCard';
import DuaCard from '../components/DuaCard';
import FadeIn from '../components/FadeIn';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Layout from '../components/Layout';

import Image from 'next/image';
import Link from 'next/link';
import { gql } from '../generated';
import { GetBooksQuery, GetDuasQuery } from '../generated/graphql';
import { isDev } from '../utils/utils';

export const GET_BOOKS_QUERY = gql(`
  query getBooks {
    allBooks {
      id
      name
      volumes
      enabled
      version
      authorName
      altTitle
      translator
      englishName
    }
  }
`);

const GET_DUAS_QUERY = gql(`
  query getDuas {
    allDuas {
      id
      name
      languages
      path
      verseGroups {
        name
        language
        verses {
          id
          index
          content
        }
      }
    }
  }
`);

// This function gets called at build time and helps statically generate the page
export async function getStaticProps() {
  const { data } = await client.query({
    query: GET_BOOKS_QUERY,
  });

  const { data: duaData } = await client.query({
    query: GET_DUAS_QUERY,
  });

  console.log('data', duaData);

  // // we need to load the svg placeholders for the images here before rendering the page
  // const uris = data?.allBooks?.map((book) => `/css/images/${book?.id}.jpeg`) ?? [];
  // let svgs = [];
  // let imgs = [];

  // for (let i = 0; i < uris.length; i++) {
  //   const { img, svg } = await getPlaiceholder(uris[i], {
  //     size: 64,
  //   });
  //   svgs.push(svg);
  //   imgs.push(img);
  // }

  return {
    props: {
      books: data?.allBooks,
      duas: duaData?.allDuas,
    },
  };
}

const swipeConfidenceThreshold = 10000;
const swipePower = (offset: number, velocity: number) => {
  return Math.abs(offset) * velocity;
};

export default function Home(
  {
    books,
    duas,
    initialLoad,
    imgs,
    svgs,
  }: { books: GetBooksQuery['allBooks']; initialLoad: any; imgs: any; svgs: any; duas: GetDuasQuery['allDuas'] },
  ref: any
) {
  const [pageLoaded, setPageLoaded] = useState(false);
  // const [duas, setDuas] = useState(false);
  const [[page, direction], setPage] = useState([0, 0]);
  const [isOn, setIsOn] = useState(false);
  const toggleSwitch = () => {
    setIsOn(!isOn);

    if (isOn) {
      paginate(-1);
    } else {
      paginate(1);
    }
  };

  const imageIndex = wrap(0, 2, page);

  const paginate = (newDirection: number) => {
    setPage([page + newDirection, newDirection]);
  };
  useEffect(() => {
    setPageLoaded(true);
  }, []);

  const variants = {
    enter: (direction: number) => {
      return {
        x: direction > 0 ? 1000 : -1000,
        opacity: 0,
      };
    },
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1,
    },
    exit: (direction: number) => {
      return {
        zIndex: 0,
        x: direction < 0 ? 1000 : -1000,
        opacity: 0,
      };
    },
  };

  const pp = <Card>heloooo</Card>;

  const activeTabClass =
    'text-gray-800 bg-stone-200 dark:bg-gray-800 dark:text-gray-300 border-t border-x border-gray-300';

  return (
    <Layout ref={ref}>
      <Header description="Thaqalayn.net - The comprehensive Shia Hadith Library" title="Hadith Library" />
      <div className="flex flex-col">
        <main className="pt-10">
          <FadeIn delay={0.1} disable={!initialLoad} loaded={pageLoaded}>
            <Bismillah />
          </FadeIn>
          <FadeIn className="flex justify-center items-center" delay={0.2} disable={!initialLoad} loaded={pageLoaded}>
            <h1 className="inline text-6xl font-semibold mt-4">Thaqalayn</h1>
          </FadeIn>
          <FadeIn className="flex justify-center items-center" delay={0.2} disable={!initialLoad} loaded={pageLoaded}>
            <p className="text-lg text-center">Comprehensive Shia Hadith Library</p>
          </FadeIn>
          {isDev() && (
            <FadeIn className="md:block  mt-4" delay={0.3} disable={!initialLoad} loaded={pageLoaded}>
              <div className="w-full flex flex-row">
                <ul className="justify-center flex flex-wrap text-sm w-full font-medium text-center mx-auto text-gray-500 border-b border-gray-300 dark:border-gray-700 dark:text-gray-400">
                  <li className="mb-0 w-32 cursor-pointer" onClick={() => setPage([0, 1])}>
                    <span
                      className={`p-4 font-bold ${
                        page == 0 && activeTabClass
                      } hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300 rounded-t-lg dark:text-gray-500 flex flex-row justify-center`}
                    >
                      <Image alt="dua" className="dark:invert" height={20} src="/images/books.png" width={32} />
                      <p className="my-auto ml-2 font-bold">Hadith</p>
                    </span>
                  </li>
                  <li className="mb-0 w-32 cursor-pointer inline-block" onClick={() => setPage([1, 1])}>
                    <span
                      className={`p-4 font-bold ${
                        page == 1 && activeTabClass
                      } hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300 rounded-t-lg dark:text-gray-500 flex flex-row justify-center`}
                    >
                      <Image alt="dua" className="dark:invert" height={20} src="/images/hands.png" width={32} />
                      <p className="my-auto ml-2 font-bold">Dua</p>
                    </span>
                  </li>
                </ul>
              </div>
            </FadeIn>
          )}
          <FadeIn
            // className="grid justify-items-center 3xl:grid-cols-4 xl:grid-cols-3 lg:grid-cols-2 md:px-24 px-2 md:mt-0 mt-4 flex-grow"
            delay={0.3}
            disable={!initialLoad}
            loaded={pageLoaded}
          >
            <AnimatePresence initial={false} mode="wait">
              <motion.div
                key={page}
                className="grid justify-items-center 3xl:grid-cols-4 xl:grid-cols-3 lg:grid-cols-2 md:px-24 px-2 md:mt-0 mt-4 flex-grow"
                transition={{ duration: 1, damping: 20 }}
              >
                {page == 1
                  ? duas?.reverse()?.map((dua, i) => (
                      <motion.div
                        key={page}
                        animate={{ opacity: 1 }}
                        className="w-full"
                        exit={{ opacity: 0 }}
                        initial={{ opacity: 0 }}
                        transition={{ duration: 0.2 }}
                      >
                        <DuaCard
                          key={dua?.id}
                          arabicName={dua?.verseGroups?.find((v) => v?.language == 'AR')?.name}
                          id={String(dua?.id!)}
                          name={dua?.verseGroups?.find((v) => v?.language == 'EN')?.name}
                          path={dua?.path || ''}
                        />
                      </motion.div>
                    ))
                  : books
                      ?.filter(
                        (book) =>
                          book?.enabled && ((book.volumes || [])?.length > 0 ? book.id == book?.volumes?.[0] : true)
                      )
                      ?.map((book, i) => (
                        <motion.div
                          key={page}
                          animate={{ opacity: 1 }}
                          className="w-full"
                          exit={{ opacity: 0 }}
                          initial={{ opacity: 0 }}
                          transition={{ duration: 0.2 }}
                        >
                          <BookCard
                            key={book?.id}
                            author={book?.authorName!}
                            englishName={book?.englishName}
                            id={String(book?.id!)}
                            name={(book?.volumes || [])?.length > 0 ? book?.name?.split('- Volume')[0] : book?.name}
                          />
                        </motion.div>
                      ))}
              </motion.div>
            </AnimatePresence>
          </FadeIn>
          <FadeIn
            className="md:hidden flex flex-col justify-center items-center m-6"
            delay={0.3}
            disable={!initialLoad}
            loaded={pageLoaded}
          >
            <p>Support us:</p>
            <Link href="/donate">
              <Button auto bordered className="!-p0" color={'success'} size={'sm'}>
                Donate
              </Button>
            </Link>
          </FadeIn>
        </main>
        <div className="justify-end">
          <Footer />
        </div>
      </div>
    </Layout>
  );
}
